import { render, staticRenderFns } from "./NewEditAulaPagePolivalencia.vue?vue&type=template&id=794a7c5c&scoped=true"
import script from "./NewEditAulaPagePolivalencia.vue?vue&type=script&lang=js"
export * from "./NewEditAulaPagePolivalencia.vue?vue&type=script&lang=js"
import style0 from "./NewEditAulaPagePolivalencia.vue?vue&type=style&index=0&id=794a7c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a7c5c",
  null
  
)

export default component.exports